/* global $ */

function moveGhostLabel() {
  $('form .form-field').each(function() {
    $('input', this).focus(function() {
      $(this)
        .prev('label')
        .addClass('focus');
    });

    $('input', this).blur(function() {
      if ($(this).val() === '') {
        $(this)
          .prev('label')
          .removeClass('focus');
      }
    });
  });
}

$(document).ready(() => {
  moveGhostLabel();
});
